import React, { useState } from 'react'
import { FaLock } from 'react-icons/fa6'
import paypal from '../img/paypal.webp'
import paystack from '../img/paystacl.png'

function Donate() {
    
    const [price, setprice] = useState(0)
    const [payTime, setpayTime] = useState(false)
  
    const oneTimePrice =[
      {
        price: 50000,
        short: 50,
      },
      {
        price: 83000,
        short: 83,
      },
      {
        price: 125000,
        short: 125,
      },
      {
        price: 540000,
        short: 540,
      },
    ]
  
    const monthlyPrice =[
      {
        price: 5000,
        short: 5,
      },
      {
        price: 15000,
        short: 15,
      },
      {
        price: 35000,
        short: 35,
      },
      {
        price: 46000,
        short: 46,
      },
    ]
  
    const handlePayTimeChange = (e) => {
      payTime ? setpayTime(false) : setpayTime(true)
      const index1 = oneTimePrice?.findIndex((prc)=> prc.price === price)
      const index2 = monthlyPrice?.findIndex((prc)=> prc.price === price)
      const monthly = monthlyPrice[index1]?.price
      const one = oneTimePrice[index2]?.price
      payTime ? setprice(Number(one)) : setprice(Number(monthly))
      
    }
    
    const handlePriceChange = (value) => {
      setprice(Number(value))
    }

    
    const formattedAmount = new Intl.NumberFormat('en-US');  

    const [value, setValue] = useState("");

    const handleChange = (e) => {
      const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
      setValue(numericValue);
    };
    
  return (
    <div className='donation_pop' >
        <h3>DONATE TO HELP CHILDREN IN CRISIS</h3>
        <div className='donation_period_option' >
            <p onClick={handlePayTimeChange} style={!payTime ? {color:'white', backgroundColor:'#da291c', border:'1px solid #da291c', borderTopLeftRadius:'5px', borderBottomLeftRadius:'5px', transition:'.5s'} : {}} >ONE-TIME</p>
            <p onClick={handlePayTimeChange} style={payTime ? {color:'white', backgroundColor:'#da291c', border:'1px solid #da291c', borderTopRightRadius:'5px', borderBottomRightRadius:'5px', transition:'.5s'} : {}} >MONTHLY</p>
        </div>
        
        <div className='donation_price_option'>
            { !payTime ?
                oneTimePrice?.map((dep, i)=>(
                    price === dep.price ?
                    <p key={i} style={{color:'white', backgroundColor:'#da291c'}} >#{dep.short}k</p>
                    :
                    <p key={i} onClick={()=>handlePriceChange(dep.price)}>#{dep.short}k</p>
                ))
                : 
                monthlyPrice?.map((dep, i)=>(
                    price === dep.price ?
                    <p key={i} style={{color:'white', backgroundColor:'#da291c'}} >#{dep.short}k</p>
                    :
                    <p key={i} onClick={()=>handlePriceChange(dep.price)}>#{dep.short}k</p>
                ))
            }
        </div>

        <div className='donation_matters' >
            {
                price/1000 <= 80 && price/1000 > 0 ?
                    <p>#{formattedAmount.format(price)} could provide a nutritious meal for the children.</p>
                :
                price/1000 <= 100 && price/1000 > 0 ?
                    <p>#{formattedAmount.format(price)} could help with the children's school supply.</p>
                :
                price/1000 <= 200 && price/1000 > 0 ?
                    <p>#{formattedAmount.format(price)} could support medical care and wellness programs for the children.</p>
                :
                price/1000 >= 500 && price/1000 > 0 ?
                    <p>#{formattedAmount.format(price)} could help sustain safe housing and long-term support</p>
                :
                null
            }
        </div>

        <div className='input_field' >
            <p>#</p>
            <input value={value ? formattedAmount.format(value) : value} type='text' onChange={handleChange} placeholder='Enter other amount' />
        </div>

        {
          value < 5000 && value !== '' ?
          <p style={{color:'red'}} >Minimum Donation is 5,000</p>
          : null
        }

        <div className='donation_btn' >
            <h3>DONATE NOW</h3>
        </div>

        <div className='donation_type_img'>
            <img src={paypal} alt='' />
            <img src={paystack} alt='' />
        </div>

        <p className='donation_assurance' >
            <FaLock/>
            Your donation is processed securely
        </p>
    </div>
  )
}

export default Donate